import React, {PureComponent} from "react"
import styled from "styled-components"

import {TextButton} from "@irati/ui/src/Button"
import Icon from "@irati/ui/src/Icon"
import {greys} from "@irati/ui/src/global/colors"
import {threePxElevation, onePxElevation} from "@irati/ui/src/global/elevation"

const StyledTextButton = styled(TextButton)`
  align-items: center;
  background-color: ${greys.lightest};
  display: flex;
  justify-content: center;
  ${({size}: Props) => `
    border-radius: ${size}px;
    height: ${size}px;
    margin-left: -${size / 2}px;
    margin-right: ${size / 4}px;
    width: ${size}px;
  `}

  ${threePxElevation};
  &:focus, &:hover {
    ${threePxElevation};
    background-color: ${greys.light};
  }
  &:active {
    ${onePxElevation};
  }
`

interface Props {
  size?: number
}

class BackButton extends PureComponent<Props> {
  static defaultProps = {
    size: 50
  }

  render() {
    return (
      <StyledTextButton {...this.props}>
        <Icon icon="backArrow" size={20} />
      </StyledTextButton>
    )
  }
}

export default BackButton
